// Compact film-age marks for screening lists.
// Filled disc = legal age. Outline disc = recommended age, only when it differs.
// Dashed disc = accompanied age, only when it differs from both.
// The row reads from the lowest age to the highest. Several films: the highest age of each kind.
(function () {
    function is_set(value) {
        return value !== null && value !== undefined && value !== '';
    }

    function band(age) {
        if (age <= 0) {
            return '0';
        }
        if (age <= 8) {
            return '6';
        }
        if (age <= 12) {
            return '12';
        }
        return '16';
    }

    function highest_ages(screening) {
        var films = screening && screening.films;
        var keys = ['l_min_age', 's_min_age', 'a_min_age'];
        var highest = {};
        var i;
        var j;

        if (!films) {
            return highest;
        }
        if (!Array.isArray(films)) {
            films = [films];
        }

        for (i = 0; i < films.length; i++) {
            var opaque = films[i] && films[i].opaque;
            if (!opaque) {
                continue;
            }
            for (j = 0; j < keys.length; j++) {
                var key = keys[j];
                if (!is_set(opaque[key])) {
                    continue;
                }
                var age = parseInt(opaque[key], 10);
                if (isNaN(age)) {
                    continue;
                }
                if (highest[key] === undefined || age > highest[key]) {
                    highest[key] = age;
                }
            }
        }

        return highest;
    }

    function age_title(labels, label, age) {
        if (!age) {
            return labels.tout_public || '';
        }
        return (label || '') + ' : ' + age;
    }

    globalThis.ticketack_film_age_pictos = function (screening) {
        var labels = globalThis.ticketack_film_age_labels || {};
        var highest = highest_ages(screening);
        var legal = highest.l_min_age;
        var recommended = highest.s_min_age;
        var accompanied = highest.a_min_age;
        var pictos = [];

        if (legal) {
            pictos.push({
                text: String(legal),
                level: band(legal),
                outline: false,
                title: age_title(labels, labels.legal, legal)
            });
        }

        if (recommended && recommended !== legal) {
            pictos.push({
                text: String(recommended),
                level: band(recommended),
                outline: true,
                title: age_title(labels, labels.recommended, recommended)
            });
        }

        if (accompanied !== undefined && accompanied !== legal && accompanied !== recommended) {
            pictos.push({
                text: accompanied ? String(accompanied) : '0',
                level: band(accompanied),
                outline: false,
                dashed: true,
                title: accompanied ? age_title(labels, labels.accompanied, accompanied) : (labels.tout_public || '')
            });
        }

        if (!pictos.length && (legal === 0 || recommended === 0 || accompanied === 0)) {
            pictos.push({
                text: '0',
                level: '0',
                outline: false,
                title: labels.tout_public || ''
            });
        }

        // Float right reverses the list: highest first so the row reads low to high.
        pictos.sort(function (a, b) {
            return parseInt(b.text, 10) - parseInt(a.text, 10);
        });

        return pictos;
    };
})();
